import { Box, Card, Grid } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { HeadcountByGender } from 'modules/insights/lib/metrics/headcountByGender'

import BlankSlate from '../BlankSlate'
import HeadcountByGenderChart from './HeadcountByGenderChart'
import HeadcountByGenderLegend from './HeadcountByGenderLegend'

type Props = {
  headcountByGender: HeadcountByGender
}

const WidgetHeadcountByGender = ({ headcountByGender }: Props) => {
  const data = headcountByGender.generate()

  return (
    <Card>
      <Card.Title tooltip={i18n.t('insights.widgets.headcount_by_gender.tooltip')}>
        {i18n.t('insights.widgets.headcount_by_gender.title')}
      </Card.Title>
      <Card.Content>
        {headcountByGender.isEmpty() ? (
          <BlankSlate />
        ) : (
          <Box justifyContent="center" width="full" height="full">
            <Grid variant="fixed">
              <Box gridColSpan={{ xxs: 12, xs: 8 }} justifyContent="center" alignItems="center">
                <HeadcountByGenderChart data={data} />
              </Box>
              <Box gridColSpan={{ xxs: 12, xs: 4 }} justifyContent="center" alignItems="center">
                <HeadcountByGenderLegend data={data} />
              </Box>
            </Grid>
          </Box>
        )}
      </Card.Content>
    </Card>
  )
}

export default WidgetHeadcountByGender
